<template>
  <div>
    <div v-if="showBackButton" class="routemanagement-breadcrumb">
      <Loading :visible="loading" />
      <div v-if="showBackButton" class="breadcrumb-back">
        <a class="breadcrumb-back-link" @click="clickBack()">
          <font-awesome-icon icon="arrow-left" />
        </a>
        <slot name="parents"></slot>
      </div>
      <div class="breadcrumb-icon-panel">
        <slot name="icon"></slot>
      </div>
      <div class="object-title" :data-id="id">
        <p class="object-type" :data-id="id">{{ type }}</p>
        <span class="object-label">{{ name }}</span>
      </div>
    </div>
    <div v-else class="routemanagement-breadcrumb">
      <Loading :visible="loading" />
      <div class="breadcrumb-icon-panel-network">
        <slot name="icon"></slot>
      </div>
      <div class="object-title-network" :data-id="id">
        <p class="object-type" :data-id="id">{{ type }}</p>
        <span class="object-label">{{ name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '../Loading.vue';

export default {
  name: 'Breadcrumb',
  components: { Loading },
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    clickBack() {
      this.$emit('backButtonPressed');
    },
  },
};
</script>

<style scoped>
  .routemanagement-breadcrumb {
    display: grid;              /* 1 column, 1 row */
    grid-template-columns: 1fr;
    grid-auto-rows: auto;       /* row height = tallest overlapped child */
    position: relative;
    max-width: 400px;
  }

  .routemanagement-breadcrumb div.breadcrumb-back {
    grid-column: 1;
    grid-row: 1;
    cursor: pointer;
    display: block;
    float: left;
    width: 60px;
    height: 80px;
    line-height: 80px;
    color: #42464c;
    text-decoration: none;
    text-align: center;
    border-right: 1px solid #d9dadb;
    transition: all 0.3s ease;
    font-weight: 300;
  }

  .routemanagement-breadcrumb div.breadcrumb-back a.breadcrumb-back-link {
    color: #42464c;
    text-decoration: none;
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    font-size: 1.0em;
    margin: 0;
    padding: 0;
    outline: 0;
    transition: all 0.3s ease;
    background: transparent;
  }

  .routemanagement-breadcrumb .breadcrumb-parents {
    z-index: 10;
    transition: all 0.3s ease;
    overflow: hidden;
    position: absolute;
    left: 5px;
    border: none;
    border-radius: 3px;
    top: 62px;
    width: 404px;
  }

  .routemanagement-breadcrumb .breadcrumb-icon-panel {
    grid-column: 2;
    grid-row: 1;
    margin: 17px 6px 0px 6px;
  }

  .routemanagement-breadcrumb .object-title {
    grid-column: 3;
    grid-row: 1;
    line-height: 24px;
    display: block;
    font-size: 1.0em;
    width: 310px;
    overflow: hidden;
  }

  .routemanagement-breadcrumb .object-title .object-type {
    color: gray;
    font-size: 16px;
    line-height: 12px;
    margin: 25px 0 0;
    padding: 0;
  }

  .routemanagement-breadcrumb .object-title .object-label {
    line-height: 26px;
    font-size: 1.3em;
    display: block;
    width: 310px;
    overflow: hidden;
    box-sizing: border-box;
    outline: 0;
  }

  .routemanagement-breadcrumb .breadcrumb-icon-panel-network {
    grid-column: 1;
    grid-row: 1;
    margin: 15px 0px 11px 7px;
  }

  .routemanagement-breadcrumb .object-title-network {
    grid-column: 2;
    grid-row: 1;
    line-height: 24px;
    display: block;
    font-size: 1.0em;
    width: 340px;
    overflow: hidden;
  }

  .routemanagement-breadcrumb .object-title-network .object-type {
    color: gray;
    font-size: 16px;
    line-height: 12px;
    margin: 25px 0 0;
    padding: 0;
  }

  .routemanagement-breadcrumb .object-title-network .object-label {
    line-height: 26px;
    font-size: 1.3em;
    display: block;
    width: 340px;
    overflow: hidden;
    box-sizing: border-box;
    outline: 0;
  }
</style>
